/* globals angular */
( function () {
	'use strict';

	function observationPdf ( pdfMakeProv, pdfCommonFactory, pdfFeedback, $q, apiService, Session, asPdfTemplate, observationsApi ) {
		function generatePdf ( observation, showOptions, fileName, isPreview ) {
			var obsArr = [ angular.extend( {}, observation ) ];
			var obsArrResponse;

			function returnEmptyPromise () {
				return function emptyPromise () {
					return $q.when( [] );
				};
			}

			function passthru ( ob ) {
				return function () {
					return { 'data' : ob };
				};
			}

			function getOb ( item ) {
				var userId = Session.getCredentials().PersonnelId;
				var method = [ apiService.obs.get, passthru( item ) ];

				return method[ Number( isPreview ) ]( userId, item.id );
			}

			function getLocation ( obs ) {
				return observationsApi.getSchoolName( obs.location.observeeClientId );
			}

			function assignLoc ( loc, i ) {
				obsArrResponse[ i ].locationName = loc.District + '/' + loc.SchoolName;
			}

			$q.all(  obsArr.map( getOb ) )
			.then( function ( res ) {
				obsArrResponse = res.map( function ( item ) {
					return item.data;
				} );

				return [ isPreview ].filter( Boolean )
					.reduce( returnEmptyPromise, pdfFeedback.attachToObs )( obsArrResponse, showOptions );
			} )
			.then( function () {
				return asPdfTemplate.attachReviewers( obsArrResponse, showOptions );
			} )
			.then( function () {
				return $q.all( obsArrResponse.map( getLocation ) );
			} )
			.then( function ( locations ) {
				return locations.forEach( assignLoc );
			} )
			.then( function () {
				var pdfMake      = pdfMakeProv();
				var templateBody = asPdfTemplate.buildReport( obsArrResponse, {}, showOptions, 'observation' );

				pdfCommonFactory.templateReportOptr( showOptions, templateBody );
				templateBody.pageBreak = null;

				var pdfContents = {
					'content' : [ templateBody ]
				};

				pdfContents.styles       = pdfCommonFactory.pdfStyles();
				pdfContents.pageMargins  = [ 40, 45, 85, 45 ];
				pdfContents.defaultStyle = {
					'font' : 'OpenSans'
				};

				pdfContents.pageBreakBefore = function ( currentNode ) {
					return currentNode.id === 'signature' && currentNode.startPosition.top > 660;
				};

				pdfMake.fonts = {
					'OpenSans' : {
						'normal'      : 'OpenSans-Regular.ttf',
						'bold'        : 'OpenSans-Bold.ttf',
						'italics'     : 'OpenSans-Italic.ttf',
						'bolditalics' : 'OpenSans-BoldItalic.ttf'
					},

					'SchoolCursive' : {
						'normal' : 'SchoolCursive-Regular.ttf'
					}
				};

				pdfMake.createPdf( pdfContents ).download( fileName + '.pdf' );
			} );
		}

		return {
			'generatePdf' : generatePdf
		};
	}

	angular
		.module( 'app.observations' )
		.factory( 'observationPdf', observationPdf );

	observationPdf.$inject = [ 'pdfMake', 'pdfCommonFactory', 'pdfFeedbackFactory', '$q', 'apiService', 'Session', 'asPdfTemplateFactory', 'observationsApi' ];
} )();
